import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'hubs.studies.study-options.title',
    defaultMessage: `Study Options`,
  },
  subtitle1: {
    id: 'hubs.studies.study-options.subtitle-1',
    defaultMessage: `Many colleges offer special programs like the opportunity to study abroad or participate in internships to get on-the-job training.`,
  },
  subtitle2: {
    id: 'hubs.studies.study-options.subtitle-2',
    defaultMessage: `Nearly all colleges provide extra academic help or tutoring to students who need it.`,
  },
  optionAccelerated: {
    id: 'hubs.studies.study-options.option.accelerated',
    defaultMessage: `Accelerated Programs`,
  },
  optionCombined: {
    id: 'hubs.studies.study-options.option.combined',
    defaultMessage: `Combined Degree Programs`,
  },
  optionCooperative: {
    id: 'hubs.studies.study-options.option.cooperative',
    defaultMessage: `Cooperative Education Programs`,
  },
  optionDomestic: {
    id: 'hubs.studies.study-options.option.domestic',
    defaultMessage: `Domestic Study Away Programs`,
  },
  optionDouble: {
    id: 'hubs.studies.study-options.option.double',
    defaultMessage: `Double Major`,
  },
  optionExternal: {
    id: 'hubs.studies.study-options.option.external',
    defaultMessage: `External Degree Programs`,
  },
  optionGraduateAbroad: {
    id: 'hubs.studies.study-options.option.graduate-abroad',
    defaultMessage: `Graduate Study Abroad`,
  },
  optionGraduateAbroadCredit: {
    id: 'hubs.studies.study-options.option.graduate-abroad-credit',
    defaultMessage: `Graduate Study Abroad Credit`,
  },
  optionGraduateAbroadNonCredit: {
    id: 'hubs.studies.study-options.option.graduate-abroad-non-credit',
    defaultMessage: `Graduate Study Abroad Non Credit`,
  },
  optionHonors: {
    id: 'hubs.studies.study-options.option.honors',
    defaultMessage: `Honors Program`,
  },
  optionIndependent: {
    id: 'hubs.studies.study-options.option.independent',
    defaultMessage: `Independent Study`,
  },
  optionInternship: {
    id: 'hubs.studies.study-options.option.internship',
    defaultMessage: `Internship`,
  },
  optionOnline: {
    id: 'hubs.studies.study-options.option.online',
    defaultMessage: `Online Programs Available`,
  },
  optionAbroad: {
    id: 'hubs.studies.study-options.option.abroad',
    defaultMessage: `Study Abroad`,
  },
  optionAbroadNonCredit: {
    id: 'hubs.studies.study-options.option.abroad-non-credit',
    defaultMessage: `Study Abroad Non Credit`,
  },
  optionAbroadCredit: {
    id: 'hubs.studies.study-options.option.abroad-credit',
    defaultMessage: `Study Abroad Credit`,
  },
  optionTeacher: {
    id: 'hubs.studies.study-options.option.teacher',
    defaultMessage: `Teacher Certification Programs`,
  },
  optionWeekend: {
    id: 'hubs.studies.study-options.option.weekend',
    defaultMessage: `Weekend College`,
  },
  optionWeekendEvening: {
    id: 'hubs.studies.study-options.option.weekend-evening',
    defaultMessage: `Weekend Evening Programs`,
  },
  footer: {
    id: 'hubs.studies.study-options.footer',
    defaultMessage: `Latest available data from {lastUpdated}`,
  },
});

export default messages;
